import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AdjustConfig, AdjustLogLevel, AdjustEnvironment } from '@awesome-cordova-plugins/adjust';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  /**
   * Subject global para eventos de Super Like (ou outros eventos globais)
   */
  public superLikeSubject = new Subject<number>();

  // Estados globais migrados do AppComponent
  public isUnsubscribe: boolean = false;
  public idfa: string | null = null;
  public aaid: string | null = null;
  public adjustConfig: AdjustConfig | undefined = undefined;
  public adjustLogLevel: AdjustLogLevel | undefined = undefined;

  constructor() {
    this.setupAdjust();
  }

  setupAdjust() {
    if (environment.production) {
      this.adjustConfig = new AdjustConfig('e5ciqe49k074', AdjustEnvironment.Production);
      this.adjustLogLevel = AdjustLogLevel.Error;
    } else {
      this.adjustConfig = new AdjustConfig('e5ciqe49k074', AdjustEnvironment.Sandbox);
      this.adjustLogLevel = AdjustLogLevel.Verbose;
    }
  }

  setAdjustLogLevel() {
    if (this.adjustConfig && this.adjustLogLevel) {
      this.adjustConfig.setLogLevel(this.adjustLogLevel);
    }
  }
} 